import { createContext } from 'react';
import { MainPageableOfferStore } from '@gp/offer';

const defaultValue: MainPageableOfferStore = new MainPageableOfferStore();
export const PageableOfferStoreContext = createContext<MainPageableOfferStore>(defaultValue);